export const formatQueryParams = (filter: Array<Record<string, unknown>>) => {
  const queryParams: string[] = [];

  if (!filter.length) {
    return "";
  }
  filter.forEach(item => {
    Object.entries(item).forEach(([key, value]) => {
      queryParams.push(`${key}=${value}`);
    });
  });
  const queryString = queryParams.join("&");

  if (!queryString) {
    return ``;
  }
  return `?${queryString}`;
};
